export const languageConstants = {
  LANGUAGE_TYPE: 'LANGUAGE_TYPE',
}
